import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';



const OverviewRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/recommender/overview" */
    'routes/Extensions/Recommender/OverviewRoute'
  )
));

const ConnectionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/recommender/connections" */
    'routes/Extensions/Recommender/ConnectionsRoute'
  )
));

const AnalyticsDashboardRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/recommender/analytics-dashboard" */
    'routes/Extensions/Recommender/AnalyticsDashboardRoute'
  )
));

const RecommendersRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/recommender/index" */
    'routes/Extensions/Recommender/RecommendersRoute'
  )
));

const UpdateRecommenderRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/recommender/update" */
    'routes/Extensions/Recommender/UpdateRecommenderRoute'
  )
));

const RecommenderSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/recommender/settings" */
    'routes/Extensions/Recommender/RecommenderSettingsRoute'
  )
));

const EditRecommenderSettingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/recommender/edit-settings" */
    'routes/Extensions/Recommender/EditRecommenderSettingsRoute'
  )
));

const AnalyticsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/recommender/analytics" */
    'routes/Extensions/Recommender/AnalyticsRoute'
  )
));

const OutputRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/recommender/output" */
    'routes/Extensions/Recommender/OutputRoute'
  )
));

const ConversionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/recommender/conversions" */
    'routes/Extensions/Recommender/ConversionsRoute'
  )
));

const getRecommenderRoutes = () => {
  return [
    {path: paths.getPathRecommenderOverview(), component: OverviewRoute},
    {path: paths.getPathRecommenderAnalyticsDashboard(), component: AnalyticsDashboardRoute},
    {path: paths.getPathRecommenderConnections(), component: ConnectionsRoute},

    {path: paths.getPathRecommenders(), component: RecommendersRoute},
    {path: paths.getPathAddRecommender(), component: UpdateRecommenderRoute},
    {path: paths.getPathEditRecommender(":recommenderId"), component: UpdateRecommenderRoute},

    {path: paths.getPathRecommenderSettings(), component: RecommenderSettingsRoute},
    {path: paths.getPathEditRecommenderSettings(), component: EditRecommenderSettingsRoute},

    {path: paths.getPathRecommenderAnalytics(":recommenderId"), component: AnalyticsRoute},
    {path: paths.getPathRecommenderOutput(":recommenderId"), component: OutputRoute},
    {path: paths.getPathRecommenderConversions(":recommenderId"), component: ConversionsRoute},
  ]
}


export { getRecommenderRoutes };
